import type { Message } from '~/types/local-types'
import NotificationContentAddPostalCode from '~/components/Notification/Content/NotificationContentAddPostalCode.vue'
import NotificationContentModifyPostalCode from '~/components/Notification/Content/NotificationContentModifyPostalCode.vue'
import { getEmergencyBreakActive, getEmergencyBreakNotification } from '~/composables/emergencyBreak'
import {
    getDeliveryMinimum,
    hasPostalCode,
    hasUnmetMinimumOrderQuantity,
    isPostalCodeInRange,
    meetsMinimumFreeDeliveryThreshold,
    meetsMinimumOrderThresholdForDelivery,
    meetsMinimumOrderThresholdForPickup
} from '~/composables/orderLimitations'
import { useTranslation } from '~/composables/useTranslation'
import { cart } from '~/store/cart'
import { checkout } from '~/store/checkout'
import { webshopSettings } from '~/store/webshopSettings'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
export function getOrderNotifications (): Message[] {
    // function that returns all notifications that may affect checkout or ordering
    const dispatchType = checkout().input.dispatchType
    const notifications: Message[] = []
    if (getEmergencyBreakActive(dispatchType)) {
        // @ts-expect-error - getEmergencyBreakActive already checks if getEmergencyBreakNotification is not empty
        notifications.push(getEmergencyBreakNotification(dispatchType))
    }
    if (!cart().hasCartProducts) {
        notifications.push({
            key: 'noProducts',
            message: useTranslation('cart.limitations.noProducts'),
            type: 'warning'
        })
    }
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && !meetsMinimumFreeDeliveryThreshold() && hasPostalCode() && isPostalCodeInRange()) {
        notifications.push({
            key: 'freeDeliveryThreshold',
            message: useTranslation('cart.limitations.deliveryFree', { msg: currencyFormat(webshopSettings().getCurrentDeliveryArea?.freeDeliveryThreshold) }),
            type: 'info'
        })
    }
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && hasPostalCode() && !isPostalCodeInRange()) {
        notifications.push({
            key: 'postalCodeNotInRange',
            type: 'error',
            component: NotificationContentModifyPostalCode
        })
    }
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && !hasPostalCode()) {
        notifications.push({
            key: 'noPostalCode',
            type: 'error',
            component: NotificationContentAddPostalCode
        })
    }
    if (hasUnmetMinimumOrderQuantity()) {
        notifications.push({
            key: 'hasUnmetMinimumOrderQuantity',
            type: 'error',
            message: `${useTranslation('cart.limitations.hasUnmetMinimumOrderQuantity')}`
        })
    }
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && !meetsMinimumOrderThresholdForDelivery() && cart().hasCartProducts) {
        notifications.push({
            key: 'minimumOrderThresholdDelivery',
            message: `${useTranslation('cart.limitations.onlyAllow')} ${useTranslation('cart.limitations.delivery')} ${useTranslation('cart.limitations.orderValueExceeds')} ${currencyFormat(getDeliveryMinimum())} ${useTranslation('cart.limitations.exDeliveryCosts')}.`,
            type: 'warning'
        })
    }
    if (dispatchType === DispatchTypeOrderBuddy.PICK_UP && !meetsMinimumOrderThresholdForPickup()) {
        notifications.push({
            key: 'minimumOrderThresholdPickup',
            message: `${useTranslation('cart.limitations.onlyAllow')} ${useTranslation('cart.limitations.pickup')} ${useTranslation('cart.limitations.orderValueExceeds')} ${currencyFormat(getDeliveryMinimum())} ${useTranslation('cart.limitations.exDeliveryCosts')}.`,
            type: 'warning'
        })
    }
    return notifications
}
